import React from 'react';
import { Project } from '../models/project';

// item 1454 (Chad, Copy proposal to another project: "if the projects are named the same by
// different customers, then I don't have any idea which one I'm copying it to. Can we have a
// customer header with all their projects underneath it in this drop-down list?") — the <option>s
// for a cross-customer project picker, grouped under a CUSTOMER header (native <optgroup>, so it
// works inside Chakra's Select). Customers A→Z, their projects A→Z, archived projects left out.
// Drop it inside any <Select> in place of the flat projects map.
const ProjectOptionsByCustomer: React.FC<{ projects: Project[] | undefined; excludeId?: string }> = ({ projects, excludeId }) => {
  const live = (projects ?? []).filter((p) => !p.isArchived && p.id !== excludeId);
  const groups = new Map<string, Project[]>();
  live.forEach((p) => {
    const key = (p.customerName ?? p.customer?.name ?? '').trim() || 'No customer';
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key)!.push(p);
  });
  const customers = Array.from(groups.keys()).sort((a, b) => a.localeCompare(b));
  return (
    <>
      {customers.map((c) => (
        <optgroup key={c} label={c}>
          {groups.get(c)!
            .slice()
            .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''))
            .map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
        </optgroup>
      ))}
    </>
  );
};

ProjectOptionsByCustomer.defaultProps = { excludeId: undefined };

export default ProjectOptionsByCustomer;
